export const PET_TYPES = [
  "Bird",
  "Cat",
  "Dog",
  "Equestrian",
  "Livestock",
  "Other",
  "Rabbit",
  "Reptile",
  "Small Animal",
] as const;

export type PetType = (typeof PET_TYPES)[number];
